export default __webpack_public_path__ + "static/media/bg-pattran.5faca2c7.png";